<template>
  <div class="appRepairSearch" :style="{'width':width,'height':height}">
    <van-nav-bar
      title="报修查询"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="content">
      <div class="van-title">
        <img src="../../assets/h5/bxcx.png" class="img1" alt="">
        <div class="van-title_text">报修查询</div>
      </div>
      <div class="searchsBlock">
        <div class="searchs">
          <van-icon name="search" class="icons" size="1.4rem" />
          <input
            v-model="orderNum"
            type="text"
            class="van-input"
            placeholder="请输入工单单号"
          >
        </div>
        <div class="btn" @click="handleSearch">查询</div>
      </div>
      <div v-if="flag" class="switch-blocks">
        <div class="van-title">
          <img src="../../assets/h5/bxjs.png" class="img1" alt="">
          <div class="van-title_text">报修信息</div>
        </div>
        <div class="repairMsg">
          <img
            v-if="portData.work_order_state === '已接单派发'"
            class="state"
            src="../../assets/h5/complete.png"
            alt=""
          >
          <img
            v-else
            class="state"
            src="../../assets/h5/noComplete.png"
            alt=""
          >
          <div class="slot-content">
            <div class="column">
              <div class="title">报修人</div>
              <div class="mao">:</div>
              <div class="msg">{{ portData.reporter || "暂无" }}</div>
            </div>
            <div class="column">
              <div class="title">联系电话</div>
              <div class="mao">:</div>
              <div class="msg">{{ portData.phone || "暂无" }}</div>
            </div>
            <div class="column">
              <div class="title">报修地址</div>
              <div class="mao">:</div>
              <div class="msg">{{ portData.position_name || "暂无" }}</div>
            </div>
            <div class="column">
              <div class="title">详细地址</div>
              <div class="mao">:</div>
              <div class="msg">{{ portData.position_des || "暂无" }}</div>
            </div>
            <div class="column">
              <div class="title">故障描述</div>
              <div class="mao">:</div>
              <div class="msg">{{ portData.report_inf || "暂无" }}</div>
            </div>
          </div>
        </div>
        <div class="van-title">
          <img src="../../assets/h5/bxcx.png" class="img1" alt="">
          <div class="van-title_text">报修查询</div>
        </div>
        <div class="repairMsg">
          <div class="slot-content">
            <div class="column">
              <div class="title">工程师</div>
              <div class="mao">:</div>
              <div class="msg">{{ portData.maintenance_worker || "暂无" }}</div>
            </div>
            <div class="column">
              <div class="title">联系电话</div>
              <div class="mao">:</div>
              <div class="msg">{{ portData.maintenance_worker_phone || "暂无" }}</div>
            </div>
            <div class="column">
              <div class="title">处置过程</div>
              <div class="mao">:</div>
              <div class="msg">{{ portData.handle_content || "暂无" }}</div>
            </div>
            <div class="column">
              <div class="title">完成状态</div>
              <div class="mao">:</div>
              <div class="msg">{{ portData.completion || "暂无" }}</div>
            </div>
            <div class="column">
              <div class="title">满意度</div>
              <div class="mao">:</div>
              <div class="msg">{{ portData.satisfaction || "暂无" }}</div>
            </div>
          </div>
        </div>

      </div>
      <div v-else class="empty">
        <van-empty style="margin-top:1.875rem" />
      </div>
    </div>
    <van-popup v-model="show">
      <img :src="url" class="popupImg" alt="">
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'AppRepairSearch',
  components: {},
  data() {
    return {
      orderNum: '',
      width: '0',
      height: '0',
      url: '',
      show: false,
      flag: false,
      portData: {},
      queryId: ''
    }
  },
  created() {
    if (this.$route.query.queryId) {
      this.queryId = this.$route.query.queryId
    }
    if (this.$route.query.id) {
      this.orderNum = this.$route.query.id
      this.handleSearch()
    }
    this.getBrowserInterfaceSize()
  },
  methods: {
    onClickLeft() {
      if (this.queryId) {
        this.$router.push('/appRepair?id=' + this.queryId)
      } else {
        this.$router.push('/appRepair')
      }
    },
    getBrowserInterfaceSize() {
      var pageWidth = window.innerWidth
      var pageHeight = window.innerHeight
      if (typeof pageWidth !== 'number') {
        // 在标准模式下面
        if (document.compatMode === 'CSS1Compat') {
          pageWidth = document.documentElement.clientWidth
          pageHeight = document.documentElement.clientHeight
        } else {
          pageWidth = document.body.clientWidth
          pageHeight = window.body.clientHeight
        }
      }
      this.width = pageWidth + 'px'
      this.height = pageHeight + 'px'
      console.log(this.width, this.height)
    },
    handleSearch() {
      this.$axios
        .get(this.ip + '/oa/infoWorkOrder/' + this.orderNum)
        .then((response) => {
          const res = response.data
          if (res.code === 0 && res.data !== null) {
            this.flag = true
            this.portData = res.data
          } else {
            Toast({
              message: '未查询到工单信息,请确认工单号是否正确',
              duration: 4000
            })
          }
        })
    },
    seeLargeImg(url) {
      this.show = true
      this.url = url
    }
  }
}
</script>

<style scoped lang='scss'>
.appRepairSearch {
  padding-bottom: 6.25rem;

  background-color: #f5f5f5;

  .slot-content {
    .column {
      display: flex;
      .title {
        width: 3.75rem;
        text-align-last: justify;
        font-size: .8125rem;
        font-weight: 400;
        color: #000000;
        line-height: 1.3125rem;
        opacity: 0.5;
      }
      .mao {
        color: #000000;
        line-height: 1.3125rem;
        opacity: 0.5;
        padding-right: .625rem;
      }
      .msg {
        font-size: .8125rem;
        font-family: SimHei;
        font-weight: 400;
        color: rgba(46, 61, 121, 1) !important;
        line-height: 1.3125rem;
      }
    }
  }
  .content {
    padding: 1.0625rem 0.625rem 0;
    .img1 {
      width: 0.875rem;
      height: 0.9375rem;
    }
    .searchsBlock {
      margin: 0.625rem 0 1rem;
      height: 3.125rem;
      background-color: #fff;
      box-shadow: 0 0 0.3125rem rgba(0, 0, 0, 0.061);
      padding: 0 0.625rem;
      border-radius: 0.625rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .searchs {
        width: 16.5rem;
        height: 1.9375rem;
        border-radius: 0.3125rem;
        background-color: #f5f5f5;
        display: flex;
        align-items: center;
        .icons {
          margin: 0 0.625rem;
        }
      }
      .btn {
        width: 3.8125rem;
        height: 1.5625rem;
        font-size: 0.5rem;
        line-height: 1.5625rem;
        text-align: center;
        font-weight: 400;
        color: #ffffff;
        background: url(../../assets/h5/s-btn.png) no-repeat;
        background-size: 100% 100%;
        letter-spacing: 0.125rem;
      }
    }
    .switch-blocks {
      .msg {
        line-height: 1.3125rem;
        font-size: 0.75rem;
        color: #0000007e;
      }
      .repairMsg {
        position: relative;
        background-color: #fff;
        margin: 0.625rem 0 1.0625rem;
        padding: 1.4375rem 0 1.4375rem 1.3125rem;
        border-radius: 0.625rem;

        .state {
          position: absolute;
          right: 0.1875rem;
          top: 0.3125rem;
          width: 5.9375rem;
          height: 5.75rem;
        }

        .bottom-block {
          padding: 0.875rem 0.5625rem;
          .img-block {
            display: flex;
            align-items: center;
            margin-top: 0.875rem;
            img {
              margin-right: 0.3125rem;
              width: 4.625rem;
              height: 4.625rem;
              border-radius: 0.3125rem;
            }
          }
        }
      }
    }
  }
}
</style>
